<div class="clr-row clr-justify-content-center margin-0">
  <div class="clr-col-xl-8 clr-col-lg-9 clr-col-md-10 clr-col-sm-11 clr-col-xs-12">
    <div class="page-content">

      <h3>{{__('active-accounts')}}</h3>

      <clr-datagrid>
        <clr-dg-column [clrDgSortBy]="'name'">{{__('name')}}</clr-dg-column>
        <clr-dg-column [clrDgSortBy]="'email'">{{__('email')}}</clr-dg-column>
        <clr-dg-column [clrDgSortBy]="'keycloakId'">KeycloakId</clr-dg-column>
        <clr-dg-column [clrDgSortBy]="'startDate'">{{__('start-date')}}</clr-dg-column>
        <clr-dg-column [clrDgSortBy]="'adminInvitedEndDate'">{{__('end-date')}}</clr-dg-column>
        <clr-dg-column [clrDgSortBy]="'adminInvitedHasEndDate'">{{__('has-end-date')}}</clr-dg-column>
        <clr-dg-column></clr-dg-column>

        <clr-dg-row *clrDgItems="let user of invitedUsers">
          <clr-dg-cell>{{ user.name }}</clr-dg-cell>
          <clr-dg-cell>{{ user.email }}</clr-dg-cell>
          <clr-dg-cell>{{ user.keycloakId }}</clr-dg-cell>
          <clr-dg-cell>{{ formatDate(user.startDate) }}</clr-dg-cell>
          <clr-dg-cell>
            <input type="date"
                   [value]="formatEndDateForInput(user.adminInvitedEndDate)"
                   (change)="updateEndDate(user, $event)"
                   class="end-date-input"/>
          </clr-dg-cell>
          <clr-dg-cell>{{ user.adminInvitedHasEndDate ? '✓' : '-' }}</clr-dg-cell>
          <clr-dg-cell>
            <button (click)="toggleChatbotInvite(user)" class="id37-btn id37-btn-sm id37-btn-secondary">
              {{__('deactivate')}}
            </button>
          </clr-dg-cell>
        </clr-dg-row>

        <clr-dg-footer>
          {{invitedUsers.length}} {{invitedUsers.length === 1 ? __('result') : __('results')}}
        </clr-dg-footer>
      </clr-datagrid>

      <div class="information-text" *ngIf="showNewToggledUserText">
        {{__('jay-toggled-1')}} {{ newToggledUser.name }} {{__('jay-toggled-2')}}
      </div>

      <div class="search-input-container">
        <input [(ngModel)]="searchInputText"
               maxlength="100" placeholder="{{__('search-placeholder')}}"
               title="Search"
               type="search">

        <button *ngIf="searchInputText.length >= 3" (click)="searchUsers(searchInputText)" class="id37-btn id37-btn-sm id37-btn-secondary">
          <img alt="search" src="assets/icons/arrow_link_12x12.svg"/>
        </button>
      </div>

      <div class="information-text" *ngIf="hasSearched">
        <ng-container [ngSwitch]="foundUsers.length">
          <ng-container *ngSwitchCase="0">{{ foundUsers.length }} {{__('results')}}</ng-container>
          <ng-container *ngSwitchCase="1">{{ foundUsers.length }} {{__('result')}}</ng-container>
          <ng-container *ngSwitchDefault>{{ foundUsers.length }} {{__('results')}}</ng-container>
        </ng-container>
      </div>

      <table class="result-list" *ngIf="foundUsers.length != 0">
        <thead>
          <tr>
            <th class="search-col-name">{{__('name')}}</th>
            <th class="search-col-keycloak-id">KeycloakId</th>
            <th class="search-col-activate-button"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of foundUsers">
            <td class="search-col-name">{{ user.name }}</td>
            <td class="search-col-keycloak-id">{{ user.keycloakId }}</td>
            <td class="search-col-activate-button" (click)="toggleChatbotInvite(user)"><button>{{__('activate')}}</button></td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
